import { clearAlertModalState, setAlertModalClosed, shouldDisplayAlertModal} from "@/helpers/alertModalHelpers"
import { getAuthenticationStore, getContractStore, getCustomerStore, getInvoiceSituationStore } from "@/helpers/storeHelpers"
import { AlertModalEnum } from "@/enums/common/alert-modal.enum"
import {Ref, ref} from "vue"
import {ConsumptionGlobalSummary as ConsumptionGlobalSummaryModel} from "@/models";

interface IAlertModal {
    [key: string]: boolean
}

const alertModals = ref<IAlertModal>({})

export function useAlertModals(
    modals: AlertModalEnum[],
    ConsumptionGlobalSummaryModel: Ref<ConsumptionGlobalSummaryModel> | null = null
) {
    const initialize = async () => {
        modals.forEach(e => {
            alertModals.value[e] = false

            const shouldDisplayCookie = shouldDisplayAlertModal(e)
            if (!shouldDisplayCookie) {
                // Cancel the check because we have a cookie or a session variable.
                return 
            }

            const mappingValue: { [key: string]: () => Promise<boolean> }  = {
                [AlertModalEnum.ActivateSimCard]: async () => {
                    const contractStore = getContractStore()
                    const authStore = getAuthenticationStore()
                    if (contractStore && authStore && !authStore.isUser) {
                        return contractStore.hasAtLeastOneSimActivable
                    }
        
                    return false 
                },
                [AlertModalEnum.InvoiceSituation]: async () => {
                    const authStore = getAuthenticationStore()
                    if (!authStore || authStore.isUser) {
                        return false;
                    }

                    const customerStore = getCustomerStore()
                    const contractStore = getContractStore()
                    const invoiceSituationStore = getInvoiceSituationStore()
                    let hasOpenInvoice = false
                    if (customerStore && contractStore && invoiceSituationStore) {
                        if (customerStore.id && contractStore.currentMsisdn) {
                            await invoiceSituationStore.fetchInvoiceSituation()
                            hasOpenInvoice = invoiceSituationStore.hasOpenInvoice
                        }
                    }
                    return hasOpenInvoice && !!invoiceSituationStore?.isInDebt
                },
                [AlertModalEnum.OverspentLimitReached]: async () => {
                    if (ConsumptionGlobalSummaryModel?.value) {
                        const { overSpent, safeguard } = ConsumptionGlobalSummaryModel.value;
                        return !!overSpent?.credit && overSpent.credit >= (safeguard?.current || 0);
                    }

                    return false;
                },
            }

            mappingValue[e]().then((response) => {
                alertModals.value[e] = shouldDisplayCookie && response
            })
        })
    }

    const clearStates = () => {
        modals.forEach(e => {
            clearAlertModalState(e) 

            // Reinitialize display state to false.
            alertModals.value[e] = false
        })
    }

    const close = (parameter: AlertModalEnum) => {
        setAlertModalClosed(parameter)

        // Set display to false.
        alertModals.value[parameter] = false
    }

    return { 
        alertModals,
        close,
        clearStates,
        initialize
    };
}